import ABtestProviderBase, { getExperiments as getExperimentsBase, useABtest } from '@narf/abtest'
import { GetExperimentsType } from '@narf/abtest/build/types'
import * as Sentry from '@sentry/nextjs'

import PropTypes from 'prop-types'

import { useAuth2 } from './auth2'

const env = process.env.CUSTOM_ENV

export const ABtestProvider = ({ experiments, children }) => {
  const { memberId, siteId } = useAuth2()
  return (
    <ABtestProviderBase
      {...{
        memberId: Number(memberId),
        siteId: Number(siteId),
        env,
        experiments,
        logger: Sentry as unknown as GetExperimentsType['logger'],
      }}
    >
      {children}
    </ABtestProviderBase>
  )
}
ABtestProvider.propTypes = {
  experiments: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
}
ABtestProvider.defaultProps = {
  experiments: undefined,
}

const getExperiments = (memberId, siteId) =>
  getExperimentsBase({ memberId, siteId, env, logger: Sentry as unknown as GetExperimentsType['logger'] })

export { getExperiments, useABtest }
